<i18n>
{
	"en": {
		"cancelLabel": "Cancel",
		"confirmLabel": "Select Cargo Carrier",
		"description": "Description",
		"owner": "Owner",
		"registrationNumber": "Reg.no.",
		"searchPlaceholder": "Search text",
		"title": "Search for Cargo Carrier",
		"driver": "Driver"
	},
	"no": {
		"cancelLabel": "Avbryt",
		"confirmLabel": "Velg Transportmiddel",
		"description": "Beskrivelse",
		"owner": "Eier",
		"registrationNumber": "Reg.nr.",
		"searchPlaceholder": "Søketekst",
		"title": "Søk etter transportmiddel",
		"driver": "Sjåfør"
	}
}
</i18n>

<template>
	<t-dialog
		:icon="icon"
		:isShown="isShown"
		:title="$t('title')"
		:confirmLabel="$t('confirmLabel')"
		:cancelLabel="$t('cancelLabel')"
		:isConfirmDisabled="selectedCargoCarrier === undefined"
		iconType="bp"
		@close="onClose"
		@ok="onOk"
		@shown="onShown"
	>
		<t-form-group>
			<t-search-input v-model="searchValue" :placeholder="$t('searchPlaceholder')"/>
			<t-grid
				v-if="showGrid"
				:items="filteredItems"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinition"
				:rowHeight="40"
				:showFilters="false"
				:singleSelect="true"
				:selectableMode="['row']"
				selectable
				style="height: 400px; width: 500px;"
				@selected="setSelectedCargoCarrier"
				@enter="onEnter"
				@rowDoubleClick="selectAndClose"
			>
				<template #cargoCarrierTypeIcon="{ item }">
					<t-timpex-icon
						:icon="getStatusIcon(item.cargoCarrierType)"
						color="blue"
						size="md"
						style="padding-left: 3px;"
					/>
				</template>
			</t-grid>
		</t-form-group>
	</t-dialog>
</template>

<script>
import { cargoCarrierIcon } from '@/core';
import TDialog from '@/components/evergreen/overlays/TDialog';
import TFormGroup from '@/components/evergreen/timpex/inputs/TFormGroup';
import TSearchInput from '@/components/evergreen/inputs/TSearchInput';
import TGrid from '@/components/evergreen/timpex/grid/TGrid';
import TTimpexIcon from '@/components/evergreen/timpex/icons/TTimpexIcon';
export default {
	components: { TTimpexIcon, TGrid, TSearchInput, TFormGroup, TDialog },
	props: {
		icon: String,
		isShown: Boolean,
		items: Array,
		initialSearchValue: String
	},
	data() {
		return {
			searchValue: '',
			showGrid: false,
			selectedCargoCarrier: undefined,
			defaultColumnDefinition: { resizable: true, }
		};
	},
	computed: {
		filteredItems() {
			if (!this.searchValue || this.searchValue === '') return this.items;
			return this.items.filter(item => this.filterItem(item, this.searchValue));
		},
		columnDefinitions() {
			return [
				{
					field: 'cargoCarrierTypeIcon',
					displayName: '',
					resizable: false,
					width: 85,
				},
				{
					field: 'description',
					displayName: this.$t('description'),
					minWidth: 150,
				},
				{
					field: 'registrationNumber',
					displayName: this.$t('registrationNumber'),
					width: 90,
				},
				{
					field: 'vendor',
					displayName: this.$t('owner'),
					valueGetter: (item) => item.vendor ? item.vendor.name : '',
					minWidth: 125,
				},
				{
					field: 'driver',
					displayName: this.$t('driver'),
					valueGetter: (item) => item.driver ? item.driver.name : '',
					minWidth: 125,
				},
			];
		}
	},
	methods: {
		onShown() {
			if (this.initialSearchValue) {
				this.searchValue = this.initialSearchValue;
			}
			this.showGrid = true;
		},
		filterItem(item, searchString) {
			if (!item) return false;
			let ret = true;
			for (let c of searchString.split(' ')) {
				ret = ret &&
					( (item.description && item.description.toLowerCase().includes(c.toLowerCase()))
						|| ( item.registrationNumber && item.registrationNumber.toString().toLowerCase().includes(c.toLowerCase()) )
						|| ( item.vendor && item.vendor.name && item.vendor.name.toString().toLowerCase().includes(c.toLowerCase()) )
						|| ( item.driver && item.driver.name && item.driver.name.toString().toLowerCase().includes(c.toLowerCase()) )
					);
			}
			return ret;
		},
		selectAndClose(cargocarrierId) {
			if (!cargocarrierId) return;
			this.selectedCargoCarrier = this.items.find( x => x.id === cargocarrierId);
			this.onOk();
			this.onClose();
		},
		onEnter() {
			if (!this.selectedCargoCarrier) return;
			this.onOk();
			this.onClose();
		},
		getStatusIcon(item) {
			return cargoCarrierIcon.getIcon(item && item.iconId);
		},
		setSelectedCargoCarrier(cargoCarrierIds) {
			if (!cargoCarrierIds) return;
			let cargoCarrier = this.items.find(x => x.id === cargoCarrierIds[0]);
			this.selectedCargoCarrier = cargoCarrier;
		},
		onClose() {
			this.$emit('close');
			this.selectedCargoCarrier = undefined;
			this.searchValue = '';
			this.showGrid = false;
		},
		onOk() {
			this.$emit('ok', this.selectedCargoCarrier);
			this.selectedCargoCarrier = undefined;
			this.searchValue = '';
			this.showGrid = false;
		},
	},
};
</script>

<style>

</style>
